import { render } from "./RejectedManVerifications.vue?vue&type=template&id=72c972c6&scoped=true"
import script from "./RejectedManVerifications.vue?vue&type=script&lang=js"
export * from "./RejectedManVerifications.vue?vue&type=script&lang=js"

import "./RejectedManVerifications.vue?vue&type=style&index=0&id=72c972c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c972c6"]])

export default __exports__